import { useState } from "react"


export const Offer = ({onError}) => {

    const [offer, setOffer] = useState(false);

    return (
        <div className="form-check">
            <input type="hidden" name="offerStatus" value={offer} />
            <input className="form-check-input " type="checkbox" name="offer" onChange={() => setOffer(!offer)} checked={offer} id="offer"/>
            <label className="form-check-label" htmlFor="offer">
                Я приймаю умови <a href="">публічної оферти</a>
            </label>
            {onError['offerStatus'] && <div className="error-message">{onError['offerStatus']}</div>} 
        </div>
    )
}